// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export const reorder = <T extends unknown>(
  list: Array<T> | undefined,
  startIndex: number,
  endIndex: number
) => {
  if (!list) {
    return [];
  }

  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

/**
 * Split a list into consecutive chunks of at most `size`.
 *
 * @param list to split.
 * @param size maximum length of each chunk; must be greater than zero.
 * @returns the list of chunks, in order.
 */
export const chunkArray = <T>(list: T[], size: number): T[][] => {
  if (size < 1) {
    throw new Error(`chunkArray requires a size of at least 1, received ${size}`);
  }

  const chunks: T[][] = [];
  for (let start = 0; start < list.length; start += size) {
    chunks.push(list.slice(start, start + size));
  }

  return chunks;
};

/**
 * Return list of objects sorted according to specified property.
 *
 * @param list of objects of type T.
 * @param field property of type T used for sorting.
 * @param ascending sort objects by ascending if true; descending, if false.
 * @returns the sorted list.
 */
export const sortArrayByField = <T, F extends keyof T>(list: T[], field: F, ascending = true): T[] => {
  return list.sort((a: T, b: T) => {
    const [first, second] = ascending ? [a, b] : [b, a];
    if (first[field] < second[field]) {
      return -1;
    } else if (first[field] === second[field]) {
      return 0;
    } else {
      return 1;
    }
  }) as T[];
};
